import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'gallery-modal',
  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GalleryModalComponent implements OnInit {
  @Input() year: any;
	@Input() section: string;
  @Input() imageNum: number;
	@Input() isVisible: boolean = false;
	@Output() onVisibleChange = new EventEmitter<boolean>();

  previewSlideMode = false;
  previewSlideIndex = 0;

	constructor() {}

	array(n: number): number[] {
		return [...Array(n).keys()];
	}

	closeModal() {
    if (this.previewSlideMode) {
      this.previewSlideMode = false;
    } else {
      document.body.removeAttribute('style');
      this.isVisible = false;
      this.onVisibleChange.emit(this.isVisible);
    }
	}

  previewSlide(index) {
    this.previewSlideIndex = index;
    this.previewSlideMode = true;
  }

	// plusSlides(n){
	// 	this.showSlides(this.slideIndex += n);
	// }

	// currentSlide(n) {
	// 	this.showSlides(this.slideIndex = n);
	// }

	// showSlides(n) {
	// 	var i;
	// 	var slides = document.getElementsByClassName("highlights-image");
	// 	var image = document.getElementsByClassName("demo");
	// 	if (n > slides.length) this.slideIndex = 1;
	// 	if (n < 1) this.slideIndex = slides.length;
	// 	for (i = 0; i < slides.length; i++) {
	// 		var img = slides[i];
	// 		if (img.classList.contains("d-block")) img.classList.remove("d-block");
	// 		slides[i].classList.add("d-none");
	// 	}
	// 	for (i = 0; i < image.length; i++) {
	// 		if (image[i].classList.contains("active")) image[i].classList.remove("active");
	// 	}
	// 	var slide = slides[this.slideIndex - 1];
	// 	if (slide.classList.contains("d-none")) slide.classList.remove("d-none");
	// 	slide.classList.add("d-block");
	// 	image[this.slideIndex - 1].classList.add("active");
	// }

	ngOnDestroy(){
		this.closeModal();
	}

	ngOnInit() {}
}
